const formatStatus = (status) => {
  if (!status) return "Active";
  const s = String(status).trim().toLowerCase();
  if (s.includes("change pending") || s.includes("changes pending")) {
    return "Change Pending";
  }
  return status;
};

const getBadgeClass = (status) => {
  const s = String(status || "").trim().toLowerCase();
  if (s.includes("pending")) {
    return "badge badge--amber";
  }
  return "badge badge--green";
};

const ActivePolicies = ({ policies }) => {
  const hasPolicies = Array.isArray(policies) && policies.length > 0;

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-header-title">Active Policies</h3>
      </div>
      <div className="card-body policies-list">
        {hasPolicies ? (
          policies.map((policy) => (
            <div key={policy.id} className="policy-card">
              <div className="policy-card-header">
                <span className="policy-icon">{policy.icon}</span>
                <span className="policy-type">{policy.type}</span>
                <span className={getBadgeClass(policy.status)}>{formatStatus(policy.status)}</span>
              </div>
              <div className="policy-details">
                <p className="policy-detail-line">
                  {[policy.policyNumber, policy.carrier, policy.premium].filter(Boolean).join(" • ")}
                </p>
                <p className="policy-detail-line">
                  {[policy.expiration ? `Exp: ${policy.expiration}` : null, policy.details].filter(Boolean).join(" • ")}
                </p>
              </div>
            </div>
          ))
        ) : (
          <div className="no-policies-message">
            <span className="no-policies-icon">📄</span>
            <p>No active policies found for this account.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivePolicies;
